import PropTypes from "prop-types"
import React, { Component } from "react"
import Relay from "react-relay"
import { Link } from "react-router"
import ArticleResultMedia from "../elements/ArticleResultMedia"
import BadgeLink from "../elements/BadgeLink"
import Hexagon from "../elements/Hexagon"
import { getAccountSettings } from "../../scripts/accountSettings"
import { getStyles, getStyleTag } from "../../styles/dynamicStyles"
import { injectIntl } from "react-intl"
import markdown from "../../scripts/markdown"
import settingsMessages from "../../messages/settings"
import { filterHTML } from "../../scripts/xss"

class ArticleResult extends Component {
  static propTypes = {
    view: PropTypes.string,
    itemUrl: PropTypes.string
  }

  static defaultProps = {
    view: "default",
    itemUrl: ""
  }

  createDescriptionMarkup = description => {
    return { __html: filterHTML(markdown.render(description)) }
  }

  render() {
    const { resource, cursor, intl, itemUrl: itemUrlProp } = this.props
    const basePath = resource.type === "collection" ? "/collections/" : "/item/"
    const itemUrl = itemUrlProp || `${basePath}${resource.id}`
    const accountSettings = getAccountSettings(
      intl.formatMessage(settingsMessages.authenticAccountId)
    )
    const {
      style: { content }
    } = accountSettings.settings
    const { description, date_humanized, subject, coverage } = JSON.parse(
      "custom_fields" in resource ? resource.custom_fields : "{}"
    )
    const resourceType = "type" in resource ? resource.type : "collection"

    return (
      <article
        className="c-article"
        id={cursor}
        key={resource.id}
        data-article-type={resourceType}
        itemScope
        itemType="http://schema.org/Article"
        style={getStyles("c-article")}
      >
        {getStyleTag([
          "data-article-type-flag",
          "data-article-type-icon",
          "c-article__excerpt",
          "c-article__title",
          "c-article"
        ])}
        <div style={getStyles("c-article-inner")}>
          <ArticleResultMedia resource={resource} itemUrl={itemUrl} />
          <div
            className="c-article__content-wrap"
            style={getStyles("c-article__content-wrap")}
          >
            <div
              className="c-article__content"
              style={getStyles("c-article__content")}
            >
              {content === "type1" && (
                <Hexagon
                  icon={resource.type_icon}
                  color="#fff"
                  style={getStyles("c-article__content__hexagon")}
                />
              )}
              <h4
                className="c-article__title"
                style={getStyles([
                  "c-article__title",
                  "c-article__content__with-hexagon"
                ])}
                itemProp="name"
              >
                <Link to={itemUrl}>{resource.title}</Link>
              </h4>

              <div
                className="c-article__excerpt"
                style={getStyles("c-article__excerpt")}
              >
                {"description" in resource && (
                  <div
                    itemProp="description"
                    dangerouslySetInnerHTML={this.createDescriptionMarkup(
                      resource.description
                    )}
                  />
                )}
                {description && (
                  <div
                    itemProp="description"
                    dangerouslySetInnerHTML={this.createDescriptionMarkup(
                      description.value
                    )}
                  />
                )}
                {content === "type1" && <Link to={itemUrl}>Read More</Link>}
              </div>

              <footer className="c-article__footer" role="contentinfo">
                <dl className="c-article__defs">
                  {resource.creator && (
                    <div className="list__def c-article__defs-col">
                      <dt>Creator</dt>
                      <dd itemProp="author">{resource.creator}</dd>
                    </div>
                  )}
                  {date_humanized && (
                    <div className="list__def c-article__defs-col">
                      <dt>Date</dt>
                      <dd itemProp="dateCreated">{date_humanized.value}</dd>
                    </div>
                  )}
                  {coverage && (
                    <div className="list__def c-article__defs-col">
                      <dt>Place</dt>
                      <dd itemProp="contentLocation">{coverage.value}</dd>
                    </div>
                  )}
                  {subject &&
                    subject.length > 0 && (
                      <div className="list__def list__def--inline">
                        <dt>Tags</dt>
                        <div itemProp="keywords">
                          {subject.map(subject => (
                            <dd key={subject.value}>
                              <BadgeLink href="#">{subject.value}</BadgeLink>
                            </dd>
                          ))}
                        </div>
                      </div>
                    )}
                </dl>
              </footer>
            </div>
            {/* view === "favourites" &&   //TODO can't remove favourites
              <div className="c-article__favourite">
                <a href="#" onClick={ (e) => { e.preventDefault(); removeFavourite(resource.id)} } className="c-article__favourite-remove item-list__action" title="Remove from favourites">
                  <span className="item-list__action-text">Remove</span> <Icon icon="heart-cross"/>
                </a>
                { span className="c-article__favourite-date item-list__date" title="Date added to favourites">28 Jun 2016</span> }
                <Link className="item-list__link item-list__link--has-icon" to={itemUrl}><Icon extraClasses="item-list__icon" icon="article-type" title={resource.type}/>{resource.title}</Link>
              </div>
            */}
          </div>
        </div>
      </article>
    )
  }
}

export default Relay.createContainer(injectIntl(ArticleResult), {
  fragments: {
    resource: () => Relay.QL`
      fragment on Resource {
        id
        type
        type_icon
        title
        custom_fields
        creator
        ${ArticleResultMedia.getFragment("resource")}
    }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/modules/ArticleResult.js